export const environment = (() => {
  const MP_APP_URL = 'https://app.qa.mfg.com';

  return {
    production: false,
    API_ENDPOINT: 'https://materialapi.qa.mfg.com/api/v1', // Production API
    SHAPE_DIM_IMAGE_ENDPOINT: 'https://materialapi.qa.mfg.com', // Image Path for Shape dimensions
    DEFAULT_UOM: 'pcs',
    MP_APP_URL, // Reusing the MP_APP_URL variable
    MP_APP_LOGIN_URL: `${MP_APP_URL}/#/auth/login/simple?materialRedirect=1`,
    MP_APP_LOGOUT_URL: `${MP_APP_URL}/#/logout`,
  };
})();
